import { useState, useEffect } from "react";
import UtilityVehicle from "./UtilityVehicle";
import { useDispatch, useSelector } from 'react-redux';
import { setOrderData } from "Store/Component/BulkOrder/BulkOrderAction";
import { commonDropDownSelectionChange } from "utils";

const UtilityVehicleContainer = (props: any) => {
  const { vehicle, managedUtilityVehicleRef } = props

  const dispatch = useDispatch();

  const [seatingCapacityDropDownList, setSeatingcapacityDropDownList] = useState<any>([]);
  const [enclosedCabDropDownList, setEnclosedCabDropDownList] = useState<any>([]);
  const [capacityDropDownList, setCapacityDropDownList] = useState<any>([]);

  const { orderDetails }: any = useSelector((state?: any) => ({
    orderDetails: state.BulkOrderReducer.orderDetails
  }));

  ///Modified dropDown values as required
  useEffect(() => {
    let dropdownList:any = vehicle?.searchDropdowns?.length ? JSON.parse(JSON.stringify(vehicle?.searchDropdowns)) : []
    if (dropdownList?.length > 0) {
      dropdownList?.map((item: any) => {
        if (item?.dropdownName == "Seating Capacity") {
          const defaultSeatingCapacityOption = {
            text: "Select Seating Capacity",
            value: null
          };
          item?.dropdownList?.unshift(defaultSeatingCapacityOption);
          let seatingCapacityDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setSeatingcapacityDropDownList(seatingCapacityDropdownListTemp)
        } else if (item?.dropdownName == "Enclosed Cab") {
          const defaultEnclosedCabOption = {
            text: "Select Enclosed Cab",
            value: null
          };
          item?.dropdownList?.unshift(defaultEnclosedCabOption);
          let enclsosedCabDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setEnclosedCabDropDownList(enclsosedCabDropdownListTemp)
        } else if (item?.dropdownName == "Capacity") {
          const defaultCapacityOption = {
            text: "Select Capacity",
            value: null
          };
          item?.dropdownList?.unshift(defaultCapacityOption);
          let capacityDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setCapacityDropDownList(capacityDropdownListTemp)
        }
      })
    }
  }, [vehicle?.searchDropdowns])

  const handleSelectionChange = (e: any, item: any, name: string, nextField: number) => {
    let globalValues = {
      orderDetails: orderDetails,
      vehicle: vehicle,
      dispatch: dispatch,
    }
    commonDropDownSelectionChange(item, name, nextField, globalValues, setOrderData, managedUtilityVehicleRef)
  }

  useEffect(() => {
    managedUtilityVehicleRef.current[1]?.focus()
  }, [])

  return (
    <UtilityVehicle
      managedEquipmentValues={vehicle?.searchCriteria}
      seatingCapacityDropDownList={seatingCapacityDropDownList}
      capacityDropDownList={capacityDropDownList}
      enclosedCabDropDownList={enclosedCabDropDownList}
      managedUtilityVehicleRef={managedUtilityVehicleRef}
      handleSelectionChange={handleSelectionChange}
    />
  )
}

export default UtilityVehicleContainer;
